import { ref } from 'vue'

export function useHistory() {
  const history = ref([])
  const historyIndex = ref(0)

  function push(cmd) {
    if (!cmd) return
    history.value.push(cmd)
    historyIndex.value = history.value.length
  }

  function prev() {
    if (historyIndex.value > 0) historyIndex.value--
    return history.value[historyIndex.value] || ''
  }

  function next() {
    if (historyIndex.value < history.value.length) historyIndex.value++
    return history.value[historyIndex.value] || ''
  }

  return { history, historyIndex, push, prev, next }
}

